import axios from './request'
import Cookies from 'js-cookie'

export function fetchRedpacket(ids) {
  return axios.post('/bnbapp-node-h5/h5/promotion/redpacket/searchactivitybyactivityidlist', {
    activityIdList: ids
  })
}

export function doRedpacket({ ids, requereRedPacketInfo }) {
  return axios.post('/bnbapp-node-h5/h5/promotion/redpacket/sendcouponbatch/bnb', {
    sendCouponBatchs: ids,
    requereRedPacketInfo,
    tujia_code: Cookies.get('tujia_code') || '',
    tujia_code_site: Cookies.get('tujia_code_site') || ''
  })
}

// 查询裂变活动
export function fetchRedpacketFission(ids) {
  return axios.post('/bnbapp-node-h5/h5/promotion/redpacket/queryfissionactivitybyactivityidlist', {
    activityIdList: ids
  })
}

// 裂变领券
export function doRedpacketFission({ ids, requereRedPacketInfo, ownerMemberId = '' }) {
  return axios.post('/bnbapp-node-h5/h5/promotion/redpacket/sendfissioncoupon/bnb', {
    sendCouponBatchs: ids,
    requereRedPacketInfo,
    ownerMemberId,
    tujia_code: Cookies.get('tujia_code') || '',
    tujia_code_site: Cookies.get('tujia_code_site') || ''
  })
}

export function fetchBusRedpacket(ids) {
  return axios.post('/feapi/tnsbpromotion/bingo/h5/bpromotion/redpacket/searchactivitybyactivityidlist', {
    activityIdList: ids
  })
}

export function doBusRedpacket(ids) {
  return axios.post('/feapi/tnsbpromotion/bingo/h5/bpromotion/redpacket/sendcouponbatch', {
    sendCouponBatchs: ids
  })
}

// 获取积分信息
export function fetchPointsInfoByIds(ids) {
  const path = `/feapi/activity/h5/right/queryRights/frontIntegral`
  return axios.post(path, {
    rigConfigCodes: ids
  })
}

// 使用积分
export function receivePoints(id) {
  return axios.post('/feapi/activity/h5/right/receiveRights/frontIntegral', {
    rigConfigCode: id
  })
}
